// extracted by mini-css-extract-plugin
module.exports = {"main":"examples_main__1dwtk","item":"examples_item__1hAmI","imgLink":"examples_imgLink__2CZbj","description":"examples_description__1MxEF"};